export const EDITORS_GROUP = "EDITORS_GROUP"
export const READ_ONLY_GROUP = "READ_ONLY_GROUP"
export const DRIVER_GROUP ="DRIVER_GROUP"

export const userIsInGroup = (user, group)=>{
    let isInGroup =false;
    for(var i = 0; i < user.groups.length; i++) {
        if (user.groups[i].name === group) {
            isInGroup = true;
            break;
        }
    }
    return isInGroup;
}